import { Component } from 'react';
import { CSVReader } from 'react-papaparse';
import {
  Alert, Table, Card,
  CardImg, FormText, Button, Row, Col, Container
} from 'react-bootstrap';
import CourseSelector from './CourseSelector';
import CourseDTO from '../../../models/CourseDTO';
import { withRouter } from "react-router-dom";
import * as courseCreationAction from "../../../actions/course_management/courseManagementAction";
import EnrollmentDTO from '../../../models/EnrollmentDTO';
import CourseAttendeeDTO from '../../../models/CourseAttendeeDTO';
import PartnerCertificationsDTO from '../../../models/PartnerCertificationsDTO';
import ParsedData from '../../../models/common/ParsedData';
import { RouteComponentProps } from 'react-router';
import Header from '../Header';
import enrolls from '../../../assets/img/courseManagement/enrollment.png';

class ParseCSVFileDashboard extends Component<RouteComponentProps, {}>  {

  state = {
    // Initially, no file is selected 
    enrollments: new Array<EnrollmentDTO>(),
    courseAttendees: new Array<CourseAttendeeDTO>(),
    certifications: new Array<PartnerCertificationsDTO>(),
    fileType: '',
    uploadStatus: {
      status: '',
      message: ''
    },
    dropdownOpen: false,
    selectedCourse: new CourseDTO()
  }

  canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        this.props.history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

  componentDidMount() {
    this.canYouHaveAccess();
  }

  handleOnDrop = (data) => {
    this.setState({
      selectedCourse: {}, parsedData: [], fileType: '', uploadStatus: {
        status: '',
        message: ''
      }
    })

    this.parse2Json(data);
  };

  handleOnError = (err, file, inputElem, reason) => {
    this.setState({
      uploadStatus: {
        status: 'ERROR',
        message: err
      }
    })

    console.log(err);
  };

  handleOnRemoveFile = (data) => {
    this.setState({
      selectedCourse: {}, parsedData: [], fileType: '', uploadStatus: {
        status: '',
        message: ''
      }
    })
  };

  // Try converting the array of data into Json objects that can be sent to backend
  parse2Json = (data) => {
    // Data has the following structure [data:{...}, errors: [...], meta: {...}
    // For each row we should check that there were no errors in the parsing of that line, but for simplicity I will ignore this for now

    // Fist of all lets see what typew of file this is. enrollment files have First Name and Last Name as fields in the structure
    // Whereas pre-reqs have Course Complete in its structure
    let parsedData: Array<ParsedData> = []
    // if (data[0].data['Super Region']) {
    //   console.log('Its an Enrollment file excel')
    //   this.setState({ fileType: 'ENROLL' })

    //   parsedData = data.map(e => {
    //     return {
    //       name: e.data['First Name'] + ' ' + e.data['Last Name'],
    //       email: e.data['Email'],
    //       title: e.data['Title'],
    //       country: e.data['Country'],
    //       account: e.data['Company'],
    //       registrationDate: e.data['Member First Responded Date']
    //     }
    //   });
    //   this.setState({ enrollments: parsedData });
    // } else if (data[0].data['Campaign Name']) {
    //   console.log('Its an course attendee file.')
    //   this.setState({ fileType: 'COURSE_ATTENDEE' })
    //   parsedData = data.map(e => {
    //     return {
    //       courseCompleteDate: e.data['Member First Associated Date'],
    //       email: e.data['Email'],
    //       course: e.data['Campaign Name'],
    //       courseStatus: e.data['Member Status']
    //     }
    //   });
    //   this.setState({ courseAttendees: parsedData });
    // } else if (data[0].data['Asset name']) {
      console.log('Its the partner certifications file.')
      this.setState({ fileType: 'PARTNER_CERTIFICATIONS' })
      parsedData = data
        // .filter(e => e.data['Asset type'] === "certification")
        .map(e => {
          return {
            name: e.data['name']
            // name: e.data['User first name'] + " " + e.data['User last name'],
            // email: e.data['User email'],
            // certification: e.data['Asset name'],
            // region: e.data['User region'],
            // completionTime: e.data['Completion time'],
            // expirationTime: e.data['Expiration time'],
            // account: e.data['User company']
          }
        });
      this.setState({ certifications: parsedData })
    // } else {
    //   console.log('Invalid file type')
    // }
  }

  upload = event => {
    let data = new Array<ParsedData>();
    let url = "";
    // if (this.state.fileType === 'COURSE_ATTENDEE') {
    //   data = this.state.courseAttendees;
    //   url = "/api/course_attendee/add_excel";
    // } else if (this.state.fileType === 'ENROLL') {
    //   data = this.state.enrollments;
    //   data = data.filter(p => p.email !== undefined && p.email !== null && p.email !== "");
    //   url = "/api/courses/enrollment/" + this.state.selectedCourse.id;
    // } 
    if (this.state.fileType === 'PARTNER_CERTIFICATIONS') {
      data = this.state.certifications;
      // data = data.filter(p => p.email !== undefined && p.email !== null && p.email !== "");
      url = "/partner-certification/add";
    }

    this.callApi(url, data);
  }

  callApi = (url: string, data: Array<ParsedData>) => {
    courseCreationAction.importExcel(url, data).then(response => {
      this.setState({
        uploadStatus: {
          status: 'SUCCESS',
          message: this.state.fileType + ' data upload successfully'
        }
      });
    }).catch(
      error => {
        this.setState({
          uploadStatus: {
            status: 'ERROR',
            message: this.state.fileType + ' data upload  not loaded. ' + error.message
          }
        });
        console.log(error);
      } // Handle the error response object
    );
  }


  selectCourse = (course: CourseDTO) => {
    console.log(course);
    this.setState({ selectedCourse: course });
  }


  render() {

    var uploadStatusAlert: JSX.Element = <div></div>;
    if (this.state.uploadStatus && this.state.uploadStatus.status === 'SUCCESS') {
      uploadStatusAlert = <Alert variant="info"> {this.state.uploadStatus.message} </Alert >
    }
    else if (this.state.uploadStatus && this.state.uploadStatus.status === 'ERROR') {
      uploadStatusAlert = <Alert variant="danger"> {this.state.uploadStatus.message} </Alert >
    }

    var parsedData: JSX.Element = <div></div>;
    // if (this.state.fileType === 'ENROLL') {
    //   parsedData =
    //     <div>
    //       <Table variant="dark" hover>
    //         <thead><tr><th>Name</th><th>Email</th><th>Title</th><th>Country</th><th>Account</th><th>registration Date</th></tr></thead>
    //         <tbody>
    //           {this.state.enrollments.map((e, i) => <tr key={i}><td>{e.name}</td><td>{e.email}</td><td>{e.title}</td><td>{e.country}</td><td>{e.account}</td><td>{e.registrationDate}</td></tr>)}
    //         </tbody>
    //       </Table>
    //     </div>
    // } else if (this.state.fileType === 'COURSE_ATTENDEE') {
    //   parsedData =
    //     <div>
    //       <Alert color="danger">
    //         These are all the partners who already attendeed a bootcamp. The file is a report on SFDC
    //       </Alert>
    //       <Table variant="dark" hover>
    //         <thead><tr><th>Email</th><th>Course Name</th><th>Completed Date</th><th>partner status</th></tr></thead>
    //         <tbody>
    //           {this.state.courseAttendees.map((e, i) => <tr key={i}><td>{e.email}</td><td>{e.course}</td><td>{e.courseCompleteDate}</td><td>{e.courseStatus}</td></tr>)}
    //         </tbody>
    //       </Table>
    //     </div>
    // } else 
    if (this.state.fileType === 'PARTNER_CERTIFICATIONS') {
      parsedData =
        <div>
          <Alert color="danger">
            These are all the partners who have a certification. The file is a report on University
          </Alert>
          <Table variant="dark" hover>
            <thead><tr><th>Name</th><th>Email</th><th>Certification</th><th>Account</th><th>Region</th><th>Completion Time</th><th>Expiration Time</th></tr></thead>
            <tbody>
              {this.state.certifications.map((e, i) => <tr key={i}><td>{e.name}</td><td>{e.email}</td><td>{e.certification}</td><td>{e.account}</td><td>{e.region}</td><td>{e.completionTime}</td><td>{e.expirationTime}</td></tr>)}
            </tbody>
          </Table>
        </div>
    }

    // var courseChooser: JSX.Element = <div></div>;
    // if (this.state.fileType && this.state.fileType === 'ENROLL') {
    //   courseChooser =
    //     <CourseSelector onSelection={this.selectCourse} />
    // }

    return (
      <div>
        <Header />
        <Container className="themed-container" >
          <Row>
            <Col style={{ width: '5%' }}>
              <h1>
                Import Enroll & Pre-Reqs files
              </h1>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card style={{ width: '20rem' }}>
                <Card.Header><CardImg variant="top" src={enrolls} alt="Card image cap" /></Card.Header>
                <Card.Body>
                  <CSVReader config={{ header: true, skipEmptyLines: true }} onDrop={this.handleOnDrop} onError={this.handleOnError} addRemoveButton onRemoveFile={this.handleOnRemoveFile}>
                    <FormText>Drop CSV file here. The type of file (enroll/pre-req) will be automatically detected</FormText>
                  </CSVReader>
                </Card.Body>
                <Card.Footer>
                  <Container className="themed-container" >
                    <Row>
                      <Col>
                        {console.log(this.state.selectedCourse)}
                        <Button size='sm' color="primary" disabled={this.state.fileType === '' || (this.state.fileType === 'ENROLL' && !this.state.selectedCourse.id)} onClick={this.upload}>Submit results</Button>
                      </Col>
                      {/* <Col>
                        {courseChooser}
                      </Col> */}
                    </Row></Container>
                </Card.Footer>
              </Card>
            </Col>
            <Col sm="8">
              <div className=" small">
                {uploadStatusAlert}
                <Card>
                  <Card.Header>
                    <Card.Text><b>File Contents:</b></Card.Text>
                  </Card.Header>
                  <Card.Body>
                    {parsedData}
                  </Card.Body>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withRouter(ParseCSVFileDashboard);